import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import API from '../../../api/api'
import { useSnackbar } from '../../../helpers/hooks/useSnackbar'

export const useCheckInAttendee = () => {
  const { t } = useTranslation(['attendees'])
  const { displaySnackbar } = useSnackbar()
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)

  const checkInAttendee = async (attendeeIds, guestsIds, eventId) => {
    try {
      setIsError(false)
      setIsLoading(true)

      await API.checkIn(attendeeIds, guestsIds, eventId)

      displaySnackbar(t('attendees:notifications.attendeeCheckedIn'))
    } catch {
      displaySnackbar(t('attendees:notifications.couldNotCheckIn'), true)
      setIsError(true)
    } finally {
      setIsLoading(false)
    }
  }

  return { checkInAttendee, isLoading, isError }
}
